export default __webpack_public_path__ + "static/media/BUG_FIXING.93957ea4.jpg";